import { NavigationLinkProps } from "../../providers/Router";
import TagDetailsPage from "./pages/TagDetailsPage";

const TagsRouter: NavigationLinkProps[] = [
  {
    id: "25c3c1d7-abdd-48af-863f-325c61c30025",
    title: "Manage Tag",
    description:"",
    path: "/employees/tags/:id",
    auth: true,
    sidebar: false,
    component: TagDetailsPage,
    requiredFeature: 'ANY',
    requiredPermissions: ['ANY']
  },
];

export default TagsRouter;